import { marketStrategyFormFields } from "pages/application/opportunities/edit/proposedProject/elements/marketStrategy/MarketStrategyFormFields";
import { proposedOverviewFields } from "pages/application/opportunities/edit/proposedProject/elements/overview/form-fields";
import { permitFormFields } from "pages/application/opportunities/edit/proposedProject/elements/permits/permitFormFields";
import {
  dynamicFormFieldValidator,
  objParser,
} from "stories/components/FormRenderer/helpers";

import { unflatten } from "utils/objectUtilities";

export const EnvironmentalReportModel = () => {
  const create = (obj) => {
    if (!obj.environmental_report_available) {
      delete obj.environmental_reports;
    } else {
      delete obj.expected_obtaining_date;
    }
    return obj;
  };

  return Object.freeze({
    create,
  });
};

export const ExistingFinancingModel = () => {
  const createLender = (obj) => {
    const floatFields = [
      // "current_debt_service",
      "premium",
      "interest_rate",
      "initial_loan_amount",
      "principle_outstanding",
      "mortgage_payout_amount",
      "discharge_fee",
      "interest_reserve_amount",
    ];
    floatFields.forEach((key) => {
      if (obj[key]) obj[key] = parseFloat(obj[key]);
    });
    if (obj.loan_structure === "interest only") delete obj.amortization_period;
    ["amortization_period", "loan_term", "loan_terms"].forEach((key) => {
      if (obj[key]) {
        if (isNaN(obj[key].count)) {
          delete obj[key];
        }
      }
    });

    if (!obj.being_paid_off) {
      delete obj.mortgage_payout_amount;
      delete obj.discharge_fee_incurred;
      delete obj.discharge_fee;
    } else {
      if (!obj.discharge_fee_incurred) {
        delete obj.discharge_fee;
      }
    }

    if (!obj.interest_reserve) {
      delete obj.interest_reserve_amount;
    }

    if (obj.interest_rate_type === "variable") {
      delete obj.interest_rate;
    } else if (obj.interest_rate_type === "fixed") {
      delete obj.premium;
    }
    return obj;
  };

  const create = (obj) => {
    if (!obj.has_debt) delete obj.lenders;
    if (obj.lenders) obj.lenders.map((item) => createLender(item));
    return obj;
  };

  return Object.freeze({
    create,
  });
};

export const GeotechnicalReportModel = () => {
  const create = (obj) => {
    if (!obj.geotechnical_report_available) {
      delete obj.geotechnical_report_filename;
      delete obj.report_synopsis;
    } else {
      delete obj.expected_obtaining_date;
    }
    return obj;
  };

  return Object.freeze({
    create,
  });
};

export const OverviewModel = () => {
  const create = (obj) => {
    delete obj.address;
    delete obj.city;
    delete obj.country;
    delete obj.state_or_province;
    delete obj.google_map_url;
    delete obj.postal_code;

    const formFields = proposedOverviewFields[obj.loanType];
    const fieldsNames = dynamicFormFieldValidator(formFields, obj);

    obj = objParser(obj, fieldsNames);

    return obj;
  };

  return Object.freeze({
    create,
  });
};

export const PermitModel = () => {
  const create = async (obj) => {
    const fieldsNames = dynamicFormFieldValidator(permitFormFields, obj);
    obj = objParser(obj, unflatten(fieldsNames));

    return obj;
  };
  return Object.freeze({
    create,
  });
};

export const ScheduleModel = () => {
  const create = async (obj) => {
    ["construction_schedule", "development_schedule"].forEach((key) => {
      if (obj[key].gantt_chart) {
        delete obj[key].events;
      } else {
        delete obj[key].filename;
      }
    });
    return {
      ...obj,
    };
  };
  return Object.freeze({
    create,
  });
};

export const MarketingModel = () => {
  const create = async (obj) => {
    const fieldsNames = dynamicFormFieldValidator(
      marketStrategyFormFields,
      obj
    );
    obj = objParser(obj, unflatten(fieldsNames));

    return obj;
  };
  return Object.freeze({
    create,
  });
};

export const ProjectAppraisalModel = () => {
  const create = (obj) => {
    [
      "appraised_value_of_property",
      "appraised_value_of_land",
      "estimated_value_of_property",
      "appraised_as_complete_value_of_property",
      "appraised_cost_to_complete",
      "appraised_residual_land_value",
      "total_appraised_value_of_property",
    ].forEach((key) => {
      if (obj[key]) obj[key] = parseFloat(obj[key]);
    });

    if (!obj.third_party_appraisal) {
      return {
        appraiser_description: obj.appraiser_description,
        estimated_value_of_property: obj.estimated_value_of_property,
        third_party_appraisal: obj.third_party_appraisal,
      };
    }
    return {
      appraised_as_complete_value_of_property:
        obj.appraised_as_complete_value_of_property,
      appraised_cost_to_complete: obj.appraised_cost_to_complete,
      appraised_residual_land_value: obj.appraised_residual_land_value,
      appraised_value_of_land: obj.appraised_value_of_land,
      appraised_value_of_property: obj.appraised_value_of_property,
      appraiser_description: obj.appraiser_description,
      appraiser_name: obj.appraiser_name,
      appraiser_report_date: obj.appraiser_report_date,
      appraiser_report_filename: obj.appraiser_report_filename,
      third_party_appraisal: obj.third_party_appraisal,
      total_appraised_value_of_property: obj.total_appraised_value_of_property,
    };
  };

  return Object.freeze({
    create,
  });
};

export const SecuredPropertyDetailsModel = () => {
  const create = (obj) => {
    // TODO: this fields should be float in the api but for now it is int
    if (obj.acquisition_amount)
      obj.acquisition_amount = parseFloat(obj.acquisition_amount);
    return {
      acquisition_amount: +obj.acquisition_amount,
      ...obj,
    };
  };

  return Object.freeze({
    create,
  });
};
